import { render, staticRenderFns } from "./OptionsJiraTab.vue?vue&type=template&id=5135fbda&scoped=true&"
import script from "./OptionsJiraTab.vue?vue&type=script&lang=js&"
export * from "./OptionsJiraTab.vue?vue&type=script&lang=js&"
import style0 from "./OptionsJiraTab.vue?vue&type=style&index=0&id=5135fbda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5135fbda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
